import React from 'react';
import { Link, useMatch, useResolvedPath, useLocation } from "react-router-dom"
import { JiLogo, JiPerson } from '../components/jptr-icons';


function CustomLink({ to, children, ...props }) {
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({ path: resolvedPath.pathname, end: true });

    return (
        <div className={`navlink ${isActive ? 'active' : ''}`} >
            <Link to={to} {...props}>{children}</Link>
        </div>
    )
}

const SubMenuCldrp = () => {
    return (
        <div className='navbar-submenu-container'>
            <nav className="navbar-submenu">
                <CustomLink to="/cldrp/option1">Default</CustomLink>
                <CustomLink to="/cldrp/option2">Textile (DTG)</CustomLink>
                <CustomLink to="/cldrp/option3">Ceramic</CustomLink>
            </nav>
        </div>
    );
};

export default function Navbar({ onLogout }) {

    const location = useLocation();

    return (
        <>
            <div className="navbar-container">
                <nav className="navbar">
                    <Link to="/home">
                        <JiLogo className="ji-logo" />
                    </Link>
                    <div className='flx-Hc-3'>
                        <div className='flx-Hc-1'>
                            <CustomLink to="lkspy">spy</CustomLink>
                            <CustomLink to="lkcrv">Curve</CustomLink>
                            <CustomLink to="lkswp">Swap</CustomLink>
                            <CustomLink to="lkmrg">merge</CustomLink>
                        </div>
                        <div className='flx-Hc-1'>
                            <CustomLink to="lksis">underbase</CustomLink>
                        </div>
                        <div className='flx-Hc-1'>
                            <CustomLink to="cldrp">convert</CustomLink>
                        </div>
                        <div className='flx-Hc-1'>
                            <JiPerson className="ji-iconXL" onClick={onLogout} />
                        </div>
                    </div>

                </nav>

            </div>
            {/* {location.pathname.startsWith('/cldrp') && <SubMenuCldrp />} */}
        </>
    );
}
